/**
 * @typedef {object} PopulateRelationshipFromRequestsOptions
 * @property {any[]} list
 * @property {string} idKey
 * @property {string} newKey
 * @property {(id: string) => any} func
 */
/** @type {(options: PopulateRelationshipFromRequestsOptions) => Promise<any[]>} */
export const populateRelationshipFromRequests = async ({
  list,
  idKey,
  newKey,
  func,
}) => {
  const ids = list.map((item) => item[idKey]);
  const uniqueIds = [...new Set(ids)];
  const relatedItems = await Promise.all(uniqueIds.map((id) => func(id)));
  return list.map((item) => {
    return {
      ...item,
      [newKey]: relatedItems.find(
        (relatedItem) => relatedItem.id === item[idKey]
      ),
    };
  });
};

/**
 * @typedef {object} PopulateRelationshipFromRequestOptions
 * @property {any[]} list
 * @property {string} idKey
 * @property {string} newKey
 * @property {string} [foreignKey]
 * @property {(ids: string[]) => any} func
 */
/** @type {(options: PopulateRelationshipFromRequestOptions) => Promise<any[]>} */
export const populateRelationshipFromRequest = async ({
  list,
  idKey,
  newKey,
  foreignKey = 'id',
  func,
}) => {
  const ids = list.map((item) => item[idKey]);
  const uniqueIds = [...new Set(ids)].filter((id) => id != null);
  if (uniqueIds.length === 0) {
    return list;
  }
  const relatedItems = await func(uniqueIds);
  return list.map((item) => {
    return {
      ...item,
      [newKey]: relatedItems.find(
        (relatedItem) => relatedItem[foreignKey] === item[idKey]
      ),
    };
  });
};

/**
 * @typedef {object} PopulateHasManyRelationshipFromRequestOptions
 * @property {any[]} list
 * @property {string} idKey
 * @property {string} newKey
 * @property {(ids: string[]) => any} func
 * @property {string} [foreignKey]
 */
/** @type {(options: PopulateHasManyRelationshipFromRequestOptions) => Promise<any[]>} */
export const populateHasManyRelationshipFromRequest = async ({
  list,
  idKey,
  newKey,
  foreignKey = 'id',
  func,
}) => {
  const ids = list.map((item) => item[idKey]);
  const uniqueIds = [...new Set(ids)];
  if (uniqueIds.length === 0) {
    return list;
  }
  const relatedItems = await func(uniqueIds);
  return list.map((item) => {
    return {
      ...item,
      [newKey]: relatedItems.filter(
        (relatedItem) => relatedItem[foreignKey] === item[idKey]
      ),
    };
  });
};
